import { connect } from 'react-redux';

import LearningAdminModuleSerieFormStep1 from '../components/LearningAdminModuleSerieFormStep1';
import storage from '../../../../../lib/Storage';
import { List } from 'immutable';
import {
  loadModuleSerieAdmin,
  updateModuleSerieAdmin,
  createModuleSerieAdmin,
  moduleSerieAdminFormDestroy,
  deleteModuleSerieAdmin,
} from '../../../../../state/modules/learningsAdmin/actions';
import { findStorageType } from '../../../../../lib/Auth';

const inputs = List(['title', 'order', 'is_recommended', 'public_status']);

const mapStateToProps = (state, ownProps) => {
  const data = {},
    errors = {};
  for (const val of inputs.values()) {
    data[val] = state.entities.getIn(
      ['learningModuleSeriesAdmin', ownProps.id, val],
      ''
    );
    errors[val] = state.learningsAdmin.getIn(['form', 'errors', val]);
  }

  data['public_status'] = data['public_status'] ? data['public_status'] : 2;

  return {
    isLoading: state.learningsAdmin.get('isLoading'),
    isSubmitting: state.learningsAdmin.getIn(['form', 'isSubmitting']),
    data: data,
    errors: errors,
    success: state.learningsAdmin.getIn(['form', 'success']),
    created_id: state.learningsAdmin.getIn(['form', 'created_id']),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (partnershipId, id, cb) => {
      dispatch(loadModuleSerieAdmin(partnershipId, id, cb));
    },
    update: (id, data, cb) => {
      dispatch(updateModuleSerieAdmin(id, data, cb));
    },
    create: (data, cb) => {
      dispatch(createModuleSerieAdmin(data, cb));
    },
    destroyForm: (formState) => {
      dispatch(moduleSerieAdminFormDestroy(formState));
    },
    remove: (partnershipId, id, cb) => {
      dispatch(deleteModuleSerieAdmin(partnershipId, id, cb));
    },
  };
};

const LearningAdminModuleSerieFormStep1Container = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModuleSerieFormStep1);

export default LearningAdminModuleSerieFormStep1Container;
